import { ConcernCategory } from './concernCategory';

export interface Concern {
  id: string;
  name: string;
  description: string;
  categoryName: string;
  creationTime: string;
  categoryId: string;
  category: ConcernCategory;
  inEdit?: boolean;
}

export interface TenantConcern {
  id: string;
  name: string;
  tenantConcernId: string;
  isActive: boolean;
}

export interface UpdateTenantConcern {
  id: string;
  isActive: boolean;
}

export const InitialConcern = {
  name: '',
  inEdit: true,
};
